import { Mail, Phone, Instagram } from "lucide-react";
import { CONTACT } from "@/lib/data";

const LINKS = [
  { label: "Neden Kazakistan", href: "#neden" },
  { label: "Bölümler", href: "#bolumler" },
  { label: "Üniversiteler", href: "#universiteler" },
  { label: "Nasıl İşliyor", href: "#nasil" },
  { label: "SSS", href: "#sss" },
  { label: "İletişim", href: "#iletisim" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#141178] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="inline-flex bg-white rounded-2xl p-4 mb-5 shadow-sm">
            <img src="/logo-full.png" alt="Study in Kazakhstan" className="h-20 w-auto object-contain" />
          </div>
          <p className="text-white/70 max-w-sm leading-relaxed">
            {"Türk öğrenciler için Kazakistan'da YKS puanı olmadan, sınavsız üniversite eğitiminin en güvenilir adresi."}
          </p>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-[#FFE500] mb-4">Hızlı Bağlantılar</h4>
          <ul className="space-y-2.5">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-white/70 hover:text-white transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.2em] text-[#FFE500] mb-4">İletişim</h4>
          <ul className="space-y-3">
            <li>
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 text-white/70 hover:text-white transition-colors">
                <Mail size={16} /> {CONTACT.email}
              </a>
            </li>
            <li>
              <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 text-white/70 hover:text-white transition-colors">
                <Phone size={16} /> {CONTACT.phone}
              </a>
            </li>
          </ul>
          <div className="flex items-center gap-3 mt-5">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="grid place-items-center w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Instagram">
              <Instagram size={18} />
            </a>
            <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noopener noreferrer" className="grid place-items-center w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="WhatsApp">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347M12.05 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884" /></svg>
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-white/50">
          <span>© 2026 Study in KZ. Tüm hakları saklıdır.</span>
          <a href="/admin/login" className="hover:text-white/80 transition-colors">Yönetici Girişi</a>
        </div>
      </div>
    </footer>
  );
}
